import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {UniversityService} from '../../../shared/services/university.service';
import {StateService} from '../../../shared/services/state.service';
import {CounsellorService} from '../../../shared/services/counsellor.service';

@Component({
    selector: 'app-add-counsellor',
    templateUrl: './add-counsellor.component.html',
    styleUrls: ['./add-counsellor.component.scss']
})
export class AddCounsellorComponent implements OnChanges, OnInit {
    addCounsellorForm: FormGroup;
    id: any;
    universities: any = [];
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    states: any = [];
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                private counsellorService: CounsellorService,
                private universityService: UniversityService,
                private stateService: StateService) {
    }

    ngOnInit(): void {
        this.getStates();
    }

    ngOnChanges(): void {
        this.refresh();

    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-counsellor').toggleOpen();
    }

    refresh() {
        this.addCounsellorForm = this.fb.group({
            'name': ['', Validators.required],
            'username': ['', (!this.id) ? Validators.compose([Validators.required, Validators.pattern('^\\S*$')]) : ''],
            'email': ['', Validators.compose([Validators.required, Validators.pattern('^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
            'contact': ['', Validators.compose([Validators.required, Validators.pattern('^[5-9]{1}[0-9]{9}$')])],
            'password': ['', (!this.data || !this.data['id']) ? Validators.required : ''],
            'address': ['', (!this.id) ? Validators.required : ''],
            'state_id': [''],
            'pin': ['', (!this.id) ? Validators.required : ''],
            'designation': [''],
            'experience': [''],
            'rating': ['', Validators.compose([Validators.min(0), Validators.max(5)])],
            'tags': [''],
        });
        if (this.data && this.data['user'] && this.data['user']['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addCounsellorForm.patchValue({
            'name': (this.data && this.data['user'] && this.data['user']['name']) ? this.data['user']['name'] : '',
            'username': (this.data && this.data['user'] && this.data['user']['username']) ? this.data['user']['username'] : '',
            'email': (this.data && this.data['user'] && this.data['user']['email']) ? this.data['user']['email'] : '',
            'contact': (this.data && this.data['user'] && this.data['user']['contact']) ? this.data['user']['contact'] : '',
            'address': (this.data && this.data['address']) ? this.data['address'] : '',
            'state_id': (this.data && this.data['state'] && this.data['state'].id) ? this.data['state'].id : '',
            'pin': (this.data && this.data['pin']) ? this.data['pin'] : '',
            'designation': (this.data && this.data['designation']) ? this.data['designation'] : '',
            'experience': (this.data && this.data['experience']) ? this.data['experience'] : '',
            'rating': (this.data && this.data['rating']) ? this.data['rating'] : '',
            'tags': (this.data && this.data['tags'] && this.data['tags'].length > 0) ? this.data['tags'].join(', ') : '',
        });
    }

    getStates() {
        this.stateService.get().subscribe(data => {
            if (data && data['data'].length > 0) {
                this.states = data['data'];
            }
        });
    }

    parseTags(): string[] {
        const raw: string = this.addCounsellorForm.value && this.addCounsellorForm.value.tags ? this.addCounsellorForm.value.tags : '';
        return raw.split(',').map((tag: string) => tag.trim()).filter((tag: string) => tag.length > 0);
    }

    submit() {
        this.submitted = true;
        if (!this.addCounsellorForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addCounsellorForm.value && this.addCounsellorForm.value.name) ? this.addCounsellorForm.value.name : '',
                'username': (this.addCounsellorForm.value && this.addCounsellorForm.value.username) ? this.addCounsellorForm.value.username : '',
                'email': (this.addCounsellorForm.value && this.addCounsellorForm.value.email) ? this.addCounsellorForm.value.email : '',
                'contact': (this.addCounsellorForm.value && this.addCounsellorForm.value.contact) ? this.addCounsellorForm.value.contact : '',
                'password': (this.addCounsellorForm.value && this.addCounsellorForm.value.password) ? this.addCounsellorForm.value.password : '',
                'address': (this.addCounsellorForm.value && this.addCounsellorForm.value.address) ? this.addCounsellorForm.value.address : '',
                'state_id': (this.addCounsellorForm.value && this.addCounsellorForm.value.state_id) ? this.addCounsellorForm.value.state_id : '',
                'pin': (this.addCounsellorForm.value && this.addCounsellorForm.value.pin) ? this.addCounsellorForm.value.pin : '',
                'designation': (this.addCounsellorForm.value && this.addCounsellorForm.value.designation) ? this.addCounsellorForm.value.designation : '',
                'experience': (this.addCounsellorForm.value && this.addCounsellorForm.value.experience) ? this.addCounsellorForm.value.experience : '',
                'rating': (this.addCounsellorForm.value && this.addCounsellorForm.value.rating) ? this.addCounsellorForm.value.rating : '',
                'tags': this.parseTags(),
            };
            this.submitting = true;
            this.counsellorService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addCounsellorForm.reset();
                    this.addCounsellorForm.patchValue({
                        'name': '',
                        'username': '',
                        'email': '',
                        'contact': '',
                        'password': '',
                        'address': '',
                        'state_id': '',
                        'pin': '',
                        'designation': '',
                        'experience': '',
                        'rating': '',
                        'tags': '',
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addCounsellorForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addCounsellorForm.value && this.addCounsellorForm.value.name) ? this.addCounsellorForm.value.name : '',
                'username': (this.addCounsellorForm.value && this.addCounsellorForm.value.username) ? this.addCounsellorForm.value.username : '',
                'email': (this.addCounsellorForm.value && this.addCounsellorForm.value.email) ? this.addCounsellorForm.value.email : '',
                'contact': (this.addCounsellorForm.value && this.addCounsellorForm.value.contact) ? this.addCounsellorForm.value.contact : '',
                'password': (this.addCounsellorForm.value && this.addCounsellorForm.value.password) ? this.addCounsellorForm.value.password : '',
                'address': (this.addCounsellorForm.value && this.addCounsellorForm.value.address) ? this.addCounsellorForm.value.address : '',
                'state_id': (this.addCounsellorForm.value && this.addCounsellorForm.value.state_id) ? this.addCounsellorForm.value.state_id : '',
                'pin': (this.addCounsellorForm.value && this.addCounsellorForm.value.pin) ? this.addCounsellorForm.value.pin : '',
                'designation': (this.addCounsellorForm.value && this.addCounsellorForm.value.designation) ? this.addCounsellorForm.value.designation : '',
                'experience': (this.addCounsellorForm.value && this.addCounsellorForm.value.experience) ? this.addCounsellorForm.value.experience : '',
                'rating': (this.addCounsellorForm.value && this.addCounsellorForm.value.rating) ? this.addCounsellorForm.value.rating : '',
                'tags': this.parseTags(),
            };
            this.submitting = true;
            this.counsellorService.update(this.data['user'].id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }
}
